import Vue from 'vue'

Vue.component('vue-mini-cart-item', {
  template: '#vue-mini-cart-item-template',
  props: [
    'cartLink',
    'count',
    'deleteUrl',
    'editUrl',
    'id',
    'images',
    'points',
    'pointsType',
    'title',
    'totalPoints',
    'url',
  ],
})
